import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { updateProfile } from "./profiles"; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateOnboardingType = function updateOnboardingType(onboardingType) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateOnboardingType',
    profileType: NwApiSDK.IDENTITY_PROFILES.ONBOARDING_PROFILE,
    data: {
      onboarding_type: onboardingType
    },
    showMessages: showMessages,
    meta: {
      updating: 'onboarding_type'
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateOnboardingInterest = function updateOnboardingInterest(onboardingInterest) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateOnboardingInterest',
    profileType: NwApiSDK.IDENTITY_PROFILES.ONBOARDING_PROFILE,
    data: {
      onboarding_interest: onboardingInterest
    },
    showMessages: showMessages,
    meta: {
      updating: 'onboarding_interest'
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateOnboardingProfile = function updateOnboardingProfile(data) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateOnboardingProfile',
    profileType: NwApiSDK.IDENTITY_PROFILES.ONBOARDING_PROFILE,
    data: data,
    showMessages: showMessages,
    meta: {
      updating: 'onboarding_profile'
    }
  });
};